import { $messageCentreStore } from '@lib/store';
import { DateUtils } from '@shared/utils';
import type { ThreadMessagesResponse } from '@shared/api';
import { MessageWrapper } from './messageWrapper';
import { Button, Icon, File, Text } from '@shared/widgets';
import ShareIcon from '@assets/icons/share.svg';

export interface IMessageProps {
  message: ThreadMessagesResponse;
  onClickReply: () => void;
}

export const Message = (props: IMessageProps) => {
  const downloadHandler = (fileId: string, messageId: string) => {
    $messageCentreStore.events.downloadAttachment({ fileId, messageId });
  };

  return (
    <MessageWrapper className='pl-4'>
      <div className='min-w-[0] flex-auto'>
        <Text className='mb-2' size='sm' color='gray'>
          {DateUtils.formatDate(props.message.createdOn, { withTime: true })}
        </Text>
        <div className='mb-2'>
          <Text size='sm'>{props.message.body}</Text>
        </div>
        {props.message.attachments?.map((attachment) => (
          <File key={attachment.id} attachment={attachment} onDownload={() => downloadHandler(attachment.id, props.message.messageId)} />
        ))}
      </div>
      <div className='ml-5 flex flex-none flex-col items-end'>
        <div className='mt-auto'>
          <Button className='p-1' color='icon' onClick={props.onClickReply}>
            <Icon icon={<ShareIcon />} />
          </Button>
        </div>
      </div>
    </MessageWrapper>
  );
};
